import React, { useState, useCallback, ComponentProps } from 'react';
import { TableRow } from '@amzn/meridian/table';

// Expandable rows can be "uncontrolled", managing their own state.
// Be sure to pass the `rowComponents` prop to each Meridian row instance.
interface IUncontrolledExpandableRowProps extends ComponentProps<typeof TableRow> {
  children: any;
  rowComponents?: any;
  className?: string;
  onClick?: () => void;
  dataCy?: string;
}

/**
 * Expandable TableRow
 */
const UncontrolledExpandableRow = (props: IUncontrolledExpandableRowProps) => {
  const { children, rowComponents, onClick, dataCy, ...otherProps } = props;
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => {
    setOpen(!open);
    onClick?.();
  }, [onClick, open]);

  // Return
  return (
    <TableRow
      open={open}
      onClick={toggleOpen}
      rowComponents={rowComponents}
      data-cy={dataCy !== undefined ? dataCy : ''}
      {...otherProps}
    >
      {children}
    </TableRow>
  );
};

export default UncontrolledExpandableRow;
